import { render, staticRenderFns } from "./FormSix.vue?vue&type=template&id=4b4e65c0&scoped=true&"
import script from "./FormSix.vue?vue&type=script&lang=js&"
export * from "./FormSix.vue?vue&type=script&lang=js&"
import style0 from "./FormSix.vue?vue&type=style&index=0&id=4b4e65c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e65c0",
  null
  
)

export default component.exports